import React from 'react';
import InputSearch from '../../components/InputSearch/InputSearch';

const SearchUser = () => {
  return (
    <div>
      <InputSearch />
    </div>
  );
};

export default SearchUser;
